import { createFlagsmithInstance } from '@mint-lib/flags';
import {
  FlagsmithProviders,
  type FlagsmithProviderProps,
} from '@mint-lib/flags-envs';

import { type MintAdminServiceLocatorAbstractFactoryContext } from '../types.js';

export async function flagsmithAbstractFactory(
  ctx: MintAdminServiceLocatorAbstractFactoryContext,
  name: keyof typeof FlagsmithProviders,
) {
  const providerSettings: FlagsmithProviderProps = FlagsmithProviders[name];
  const client = createFlagsmithInstance();
  const events = await ctx.getOrThrow('flagsmithEvents', name);
  const auth = await ctx.getOrThrow('auth');

  // TODO: remove it when have normal user profile for admin
  let ffId;
  if (auth.isLoggedIn()) {
    const userMeta: { data: { items: { ffId: string }[] } } =
      await ctx.getOrThrow('request', 'mdm/meta/user');
    ffId = userMeta.data?.items?.[0]?.ffId;
  }

  client._trigger = () => {
    events.emit('event');
  };

  client._triggerLoadingState = () => {
    events.emit('loadingEvent');
  };

  const datadogRum = await ctx.getOrThrow('datadog');
  await client.init({
    environmentID: providerSettings.envID,
    cacheFlags: true,
    identity: ffId,
    // @ts-ignore TS2339: Property 'options' does not exist on type.
    ...providerSettings.options,
    datadogRum: {
      client: datadogRum,
      trackTraits: true,
    },
  });

  return client;
}
